export default {
    "tickets.validation.approbationTab" : "Approvals",
}